import { Paint } from '../types/Paint';
import OAuthClient from './oauth.client';

class PaintServiceClient {
  url = process.env.REACT_APP_PS_URL;
  oauth: OAuthClient;

  constructor() {
    this.oauth = new OAuthClient();
  }

  async getTeamPaints(teamId: string): Promise<Paint[]> {
    return this.oauth
      .fetch(`${this.url}/paints/team/${teamId}`)
      .then((res) => res.json());
  }

  async getPaintQueue(teamId: string): Promise<number> {
    return this.oauth
      .fetch(`${this.url}/paints/team/processing/${teamId}`)
      .then((res) => res.json())
      .then((r) => {
        return r.count ? r.count : 0;
      });
  }

  async getPaintError(teamId: string): Promise<number> {
    return this.oauth
      .fetch(`${this.url}/paints/team/error/${teamId}`)
      .then((res) => res.json())
      .then((r) => {
        return r.count ? r.count : 0;
      });
  }

  async getPaintsByStatus(teamId: string, status: string): Promise<Paint[]> {
    return this.oauth
      .fetch(`${this.url}/paints/team/${teamId}/status/${status}`)
      .then((res) => res.json());
  }
        

  async recent(page: Number, take: Number): Promise<Paint[]> {
    return this.oauth
      .fetch(`${this.url}/paints/recent?page=${page}&take=${take}`, "GET")
      .then((res) => res.json());
  }

  async approve(paintId: string): Promise<Response> {
    return this.oauth
      .fetch(`${this.url}/paint/${paintId}/approve`, "PUT")
      .then((res) => res.json())
      .then((r) => {
        if (r.status === "OK") {
          return r;
        } else {
          throw new Error(`Failed: ${r.message}: ${r.errors.join(", ")}`);
        }
      });
  }

  async reject(paintId: string): Promise<Response> {
    return this.oauth
      .fetch(`${this.url}/paints/${paintId}/reject`, "PUT")
      .then((res) => res.json())
      .then((r) => {
        if (r.status === "OK") {
          return r;
        } else {
          throw new Error(`Failed: ${r.message}: ${r.errors.join(", ")}`);
        }
      });
  }
}

export default PaintServiceClient;
